import { render, staticRenderFns } from "./registration-by-login.vue?vue&type=template&id=ab886d50"
import script from "./registration-by-login.vue?vue&type=script&lang=js"
export * from "./registration-by-login.vue?vue&type=script&lang=js"
import style0 from "./registration-by-login.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-login.vue
// module id = VGzb
// module chunks = 0